import { useSelector } from 'react-redux';
import { useTranslate } from '../../../../../context/languageContext';
import { R } from '../../../../../R';
import RouteDetailStopCol from './RouteDetailStopCol';
import { VM } from '../../../../../../viewmodel/VM';
import ReactTooltip from "react-tooltip";
import { MdStairs as Escalator, MdElevator as Elevator } from "react-icons/md";
import { agencyInformation } from '../../../../../../redux/slices/agencySlice';
import { stopInfoByStopId } from '../../../../../../redux/slices/markersSlice';
import { FaWheelchair } from "react-icons/fa";
import Alert from '../../../../../components/commons/Alert';
import LineIcon from '../../searcherOption/stopDetail/LineIcon';

export default function RouteDetailSynoptic(props: any) {
  const t = useTranslate();
  const dataOriginAg = useSelector(agencyInformation).dataOrigin;

  const ArrowRight = R.drawables.general.Ic_arrowright;
  const Link = R.drawables.general.Ic_Link;
  const ExclamationIcon = R.drawables.commons.exclaimation;
  const plan = useSelector(
    (state: any) => state.eventsModalstoggleVisibilitySlice.ModalWidget.RouteDetailModalWidget.plan
  );

  const getMoreInformation = () => {
    let res = [] as any;
    let add = [] as any;
    for (let element in plan.lineSynoptic) {
      if (
        plan.lineSynoptic[element].mode !== 'WALK' &&
        add.indexOf(plan.lineSynoptic[element].name) < 0
      ) {
        let agencyId = plan.lineSynoptic[element]?.agencyId;
        let dataOrigin: any = dataOriginAg.find((element: any) => {
          return element.gtfsAgency.find(
            (agency: any) => parseInt(agency.id) === parseInt(agencyId)
          );
        });

        let agency = dataOrigin?.gtfsAgency?.find(
          (element: any) => parseInt(element.id) === parseInt(agencyId)
        );
        res.push(
          <div key={element} className={'padding10'}>
            <div className={'secondaryText'} style={{ fontWeight: 600 }}>
              {'-' + plan.lineSynoptic[element].name}
            </div>
            {plan.lineSynoptic[element].web && agency ? <div className="row" style={{ alignItems: 'center' }}>
              <a
                className={'secondaryText margin5'}
                href={agency?.url}
                target="_blank">
                {t('website')}
              </a>
              <Link style={{ width: 20, marginLeft: 8 }} />
            </div> : null}

            {plan.lineSynoptic[element]?.fareUrl && agency ? (
              <div className="row" style={{ alignItems: 'center' }}>
                <a
                  className={'secondaryText margin5'}
                  href={agency?.fareUrl}
                  target="_blank">
                  {t('fares')}
                </a>
                <Link style={{ width: 20, marginLeft: 8 }} />
              </div>
            ) : null}
            {plan.lineSynoptic[element]?.reserva_message &&
              plan.lineSynoptic[element]?.reserva_link && agency ? (
              <div className={'secondaryText margin5 margin-top-20'}>
                <div className={'secondaryText'}>{agency?.message}</div>
                <a
                  className={'secondaryText'}
                  href={agency?.link}
                  target="_blank">
                  {agency?.link}
                </a>
              </div>
            ) : null}
            <div className={'secondaryText margin5'}>{plan.lineSynoptic[element].telf}</div>
          </div>
        );
      }
      add.push(plan.lineSynoptic[element].name);
    }
    res.unshift(
      <div key={'moreInf'} className={'secondaryText margin-top-20'} style={{ fontWeight: 'bold' }}>
        {t('moreInf')}
      </div>
    );
    res.push(
      <div key={'moveInformative'} className={'paramText padding10'}>
        {t('moveInformative')}
      </div>
    );

    return res;
  };

  const useIsAccessibleStop = (stop: any) => {
    if (!stop) return false;

    const stopId = stop.stopId;
    if (!stopId) return false;

    const agencyOriginId = Number(stopId.split(':')[0]);
    const rawStopId = stop.stopCode;

    const stopInfo = useSelector(
      stopInfoByStopId(rawStopId, agencyOriginId)
    );

    return stopInfo?.wheelchairBoarding;
  };

  const TextWithAccessibleRightIcon = ({ text, showIcon, showAlert }: any) => (
    <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
      <span style={{ flex: 1 }}>{text}</span>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 4 }}>
        {showAlert ? (
          <ExclamationIcon style={{ width: 16, height: 16 }} />
        ) : null}

        {showIcon && <FaWheelchair size={16} color="gray" />}
      </div>
    </div>
  );

  const getMinutes = (t: any) => {
    if (typeof t === 'number') {
      const d = new Date(t);
      return d.getHours() * 60 + d.getMinutes();
    }
    if (typeof t === 'string') {
      const [h, m] = t.split(':');
      return Number(h) * 60 + Number(m);
    }
    return null;
  };

  const TEST_DELAY_MS = 0;//120000; // prueba: +2 minutos. Luego poner a 0 o eliminar.
  const TEST_STOP_ALERT = false;

  const addTestDelay = (time: any) => {
    return typeof time === 'number' ? time + TEST_DELAY_MS : time;
  };

  const formatTime = (time: any) => {
    return typeof time === 'number'
      ? new Date(time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      : time;
  };

  const hasDelayOverOneMinute = (time: any, estimatedTime: any) => {
    const timeMin = getMinutes(time);
    const estimatedMin = getMinutes(estimatedTime);

    return (
      timeMin != null &&
      estimatedMin != null &&
      Math.abs(timeMin - estimatedMin) > 1
    );
  };

  const isAdvance = (time: any, estimatedTime: any) => {
    const timeMin = getMinutes(time);
    const estimatedMin = getMinutes(estimatedTime);

    return (
      timeMin != null &&
      estimatedMin != null &&
      estimatedMin < timeMin
    );
  };

  const renderTimeWithDelay = ( time: any, estimatedTime: any, hasDelay: boolean ) => (
    <div className={'secondaryText columnAlign'} style={{ alignItems: 'flex-start' }}>
      <div style={{ textDecoration: hasDelay ? 'line-through' : 'none' }}>
        {formatTime(time)}
      </div>

      {hasDelay && (
        <div
          style={{
            color: isAdvance(time, estimatedTime) ? 'green' : 'red'
          }}
        >
          {formatTime(estimatedTime)}
        </div>
      )}
    </div>
  );

  const normalizeToArray = (value: any): any[] => {
    if (Array.isArray(value)) return value;

    if (Array.isArray(value?.data)) return value.data;
    if (Array.isArray(value?.lines)) return value.lines;
    if (Array.isArray(value?.items)) return value.items;

    if (value && typeof value === 'object') {
      return Object.values(value);
    }

    return [];
  };

  const getLineCode = (line: any) => {
    return String(
      line?.code ??
      line?.tripShortName ??
      line?.shortName ??
      line?.routeShortName ??
      line?.codigo ??
      line?.codigoLinea ??
      ''
    );
  };

  const getLineId = (line: any) => {
    return (
      line?.idLinea ??
      line?.id ??
      line?.lineId ??
      line?.routeId ??
      line?.idRoute ??
      null
    );
  };

  const getMatchedPlanLines = () => {
    const allLines = normalizeToArray(VM.lines?.data);
    const lineSynoptic = normalizeToArray(plan?.lineSynoptic);

    const transportLegs = lineSynoptic.filter((leg: any) => leg?.mode !== 'WALK');

    return allLines
      .map((line: any) => {
        const matchedLeg = transportLegs.find((leg: any) => {
          return getLineCode(line) === String(leg?.tripShortName ?? '');
        });

        if (!matchedLeg) return null;

        return {
          line,
          lineId: String(getLineId(line)),
          routeCode: String(matchedLeg?.tripShortName ?? ''),
          leg: matchedLeg
        };
      })
      .filter(Boolean);
  };

  const getRouteAlerts = () => {
    const alerts = normalizeToArray(VM.alerts?.data);
    const matchedPlanLines = getMatchedPlanLines();

    const lineIdToRouteCode = new Map();

    matchedPlanLines.forEach((matchedLine: any) => {
      if (matchedLine?.lineId) {
        lineIdToRouteCode.set(String(matchedLine.lineId), matchedLine.routeCode);
      }
    });

    const result = [] as any[];
    const added = new Set();

    alerts.forEach((alert: any) => {
      const alertLines = alert?.lineas ?? [];

      alertLines.forEach((alertLine: any) => {
        const routeCode = lineIdToRouteCode.get(String(alertLine?.idLinea));

        if (routeCode) {
          const key = `${alert?.idAlerta}-${routeCode}`;

          if (!added.has(key)) {
            added.add(key);

            result.push({
              ...alert,
              routeCode
            });
          }
        }
      });
    });

    return result;
  };

  const getAlertsForLeg = (leg: any) => {
    const routeCode = String(leg?.tripShortName ?? '');

    return getRouteAlerts().filter((alert: any) => {
      return String(alert?.routeCode) === routeCode;
    });
  };

  const renderRouteAlerts = () => {
      const alerts = getRouteAlerts();

      let res = [] as any;

      for (let alert in alerts) {
        res.push(
          <Alert
            key={alerts[alert].idAlerta + alert}
            style={{ margin: 5 }}
            title={`Incidencia ruta ${alerts[alert]?.routeCode}`}
            description={alerts[alert]?.descripcion}
          />
        );
      }

      return res;
  };

  const getStopDisplayName = (stop: any) => {
    if (!stop) return '';

    if (stop?.name === 'Origin') {
      return VM.plannerSegments.data['origin' as any]?.name ?? stop?.name;
    }

    if (stop?.name === 'Destination') {
      return VM.plannerSegments.data['destination' as any]?.name ?? stop?.name;
    }

    return stop?.name;
  };

  const getPlanStops = () => {
    const lineSynoptic = normalizeToArray(plan?.lineSynoptic);
    const added = new Set();

    return lineSynoptic
      .flatMap((leg: any) => [
        leg?.from,
        ...(leg?.intermediateStops ?? []),
        leg?.to
      ])
      .filter((stop: any) => stop && isRealStop(stop))
      .filter((stop: any) => {
        const key = String(stop?.stopId ?? stop?.stopCode);

        if (added.has(key)) return false;

        added.add(key);
        return true;
      })
      .map((stop: any) => ({
        ...stop,
        displayName: getStopDisplayName(stop)
      }));
  };

  const isRealStop = (stop: any) => {
    return !!(stop?.stopId || stop?.stopCode);
  };

  const getStopIdentifiers = (stop: any) => {
    return [
      stop?.stopId,
      stop?.stopCode,
      stop?.idParada,
      stop?.codigoParada
    ]
      .filter(Boolean)
      .map((value: any) => String(value));
  };

  const getAlertStopIdentifiers = (alert: any) => {
    const paradas = alert?.paradas ?? [];

    const idsFromParadas = paradas.flatMap((stop: any) => [
      stop?.stopId,
      stop?.stopCode,
      stop?.idParada,
      stop?.codigoParada,
      stop?.codParada,
      stop?.code,
      stop?.id
    ]);

    return [
      alert?.alertStopId,
      ...idsFromParadas
    ]
      .filter(Boolean)
      .map((value: any) => String(value));
  };

  const getStopAlerts = () => {
    if (TEST_STOP_ALERT) {
      const planStops = getPlanStops();

      return planStops
        .filter((stop: any) => stop?.displayName)
        .map((stop: any, index: number) => ({
          idAlerta: `TEST_STOP_ALERT_${index}_${stop?.stopId ?? stop?.stopCode ?? stop?.displayName}`,
          titulo: 'Incidencia',
          descripcion: `Alerta de prueba para la parada ${stop?.displayName}`,
          stopName: stop?.displayName,
          stopCode: stop?.stopCode,
          stopId: stop?.stopId,
          isTestAlert: true
        }));
    }

    const alerts = normalizeToArray(VM.alerts?.data);
    const planStops = getPlanStops();

    const result = [] as any[];
    const added = new Set();

    alerts.forEach((alert: any) => {
      const alertStopIds = getAlertStopIdentifiers(alert);

      planStops.forEach((stop: any) => {
        const stopIds = getStopIdentifiers(stop);

        const hasMatch = stopIds.some((stopId: string) =>
          alertStopIds.includes(stopId)
        );

        if (hasMatch) {
          const key = `${alert?.idAlerta}-${stop?.stopId ?? stop?.stopCode}`;

          if (!added.has(key)) {
            added.add(key);

            result.push({
              ...alert,
              stopName: stop?.displayName,
              stopCode: stop?.stopCode,
              stopId: stop?.stopId
            });
          }
        }
      });
    });

    return result;
  };

  const getAlertsForStop = (stop: any) => {
    if (!stop || !isRealStop(stop)) return [];

    if (TEST_STOP_ALERT) {
      const displayName = getStopDisplayName(stop);

      return [
        {
          idAlerta: `TEST_STOP_ALERT_${stop?.stopId ?? stop?.stopCode ?? displayName}`,
          titulo: 'Incidencia',
          descripcion: `Alerta de prueba para la parada ${displayName}`,
          stopName: displayName,
          stopCode: stop?.stopCode,
          stopId: stop?.stopId,
          isTestAlert: true
        }
      ];
    }

    const stopIds = getStopIdentifiers(stop);

    return getStopAlerts().filter((alert: any) => {
      const alertStopIds = [
        alert?.stopId,
        alert?.stopCode,
        ...getAlertStopIdentifiers(alert)
      ]
        .filter(Boolean)
        .map((value: any) => String(value));

      return stopIds.some((stopId: string) =>
        alertStopIds.includes(stopId)
      );
    });
  };

  const renderStopAlerts = () => {
    const alerts = getStopAlerts();

    let res = [] as any;

    for (let alert in alerts) {
      res.push(
        <Alert
          key={alerts[alert].idAlerta + '-stop-' + alert}
          style={{ margin: 5 }}
          title={`Incidencia parada ${alerts[alert]?.stopName ?? alerts[alert]?.stopCode ?? ''}`}
          description={alerts[alert]?.descripcion}
        />
      );
    }

    return res;
  };

  const renderSynoptic = () => {
    let res = [];
    let trans = false;
    let inter = 0;
    for (let mode in plan.lineSynoptic) {
      const stopFromIsAccessible = useIsAccessibleStop(plan.lineSynoptic[mode]?.from);
      if (parseInt(mode) > 0)
        if (
          plan.lineSynoptic[mode].mode === plan.lineSynoptic[parseInt(mode) - 1].mode &&
          plan.lineSynoptic[parseInt(mode)].mode != 'WALK'
        )
          trans = true;
        else trans = false;

      if (trans)
        res.push(
          <div key={'trans' + mode}>
            <div
              className={'secondaryText row'}
              style={{ alignItems: 'initial', textAlign: 'left' }}>
              {(() => {
                const previousLeg = plan.lineSynoptic[parseInt(mode) - 1];

                const end = previousLeg.endTime;
                const estimatedEnd = addTestDelay(previousLeg?.to?.estimatedArrival);

                const hasEndDelay =
                  previousLeg.mode !== 'WALK' &&
                  hasDelayOverOneMinute(end, estimatedEnd);

                return renderTimeWithDelay(
                  end,
                  estimatedEnd,
                  hasEndDelay
                );
              })()}
              <div className={'columnAlign'}>
                <div
                  className={'point'}
                  style={{
                    border: `3px solid ${plan.lineSynoptic[parseInt(mode) - 1].routeColor === '#FFFFFF'
                      ? plan.lineSynoptic[mode].routeTextColor
                      : plan.lineSynoptic[parseInt(mode) - 1].routeColor
                      }`
                  }}
                />
                <div className={'line'} />
              </div>
              <div className={'columnAlign'} style={{ alignItems: 'initial' }}>
                <div className={'primaryText'}>
                  {plan.lineSynoptic[parseInt(mode) - 1]?.to?.name}
                </div>
                <div className={'secondaryText darkGray'} style={{ marginBlock: 'auto' }}>
                  {t('transbord')}
                </div>
              </div>
            </div>
          </div>
        );
      if (
        (plan.lineSynoptic[parseInt(mode)]?.mode === 'WALK' &&
          plan.lineSynoptic[parseInt(mode) - 1]?.mode === 'WALK') ||
        (plan.lineSynoptic[mode]?.to.lat.toFixed(5) ===
          VM.plannerSegments.data[inter + 1]?.coords.latitude.toFixed(5) &&
          plan.lineSynoptic[mode]?.to.lon.toFixed(5) ===
          VM.plannerSegments.data[inter + 1]?.coords.longitude.toFixed(5))
      )
        inter = inter + 1;

      if (plan.lineSynoptic[mode].mode === 'WALK'){
        //Push Walk
        const previousLeg = plan.lineSynoptic[parseInt(mode) - 1];

        const walkStartsAfterTransport =
          !!previousLeg &&
          previousLeg.mode !== 'WALK';

        const walkTimeNode = walkStartsAfterTransport
          ? renderTimeWithDelay(
              previousLeg.endTime,
              addTestDelay(previousLeg?.to?.estimatedArrival),
              hasDelayOverOneMinute(
                previousLeg.endTime,
                addTestDelay(previousLeg?.to?.estimatedArrival)
              )
            )
        : (
            <div className={'secondaryText'}>
              {plan.lineSynoptic[mode].startTime}
            </div>
          );
        res.push(
          <div key={mode}>
            <div
              className={'secondaryText row'}
              style={{ alignItems: 'initial', textAlign: 'left' }}>
              {walkTimeNode}
              <div className={'columnAlign'}>
                {mode == '0' && parseInt(mode) - 1 < 0 ? (
                  <div className={'origin'} style={{ border: `5px solid ${'black'}` }} />
                ) : parseInt(mode) < plan.lineSynoptic?.length &&
                  plan.lineSynoptic[parseInt(mode) - 1]?.mode === 'WALK' &&
                  ((plan.lineSynoptic[parseInt(mode)]?.mode === 'WALK' &&
                    plan.lineSynoptic[parseInt(mode) - 1]?.mode === 'WALK') ||
                    (plan.lineSynoptic[mode]?.to.lat.toFixed(5) ===
                      VM.plannerSegments.data[inter]?.coords.latitude.toFixed(5) &&
                      plan.lineSynoptic[mode]?.to.lon.toFixed(5) ===
                      VM.plannerSegments.data[inter]?.coords.longitude.toFixed(5))) ? (
                  <div className={'interPoint'}>{inter}</div>
                ) : (
                  <div
                    className={'point'}
                    style={{
                      border: `3px solid ${plan.lineSynoptic[parseInt(mode) - 1].routeColor === '#FFFFFF'
                        ? plan.lineSynoptic[parseInt(mode) - 1].routeTextColor
                        : plan.lineSynoptic[parseInt(mode) - 1].routeColor ?? 'black'
                        }`
                    }}
                  />
                )}
                <div className={'dashed'} />
              </div>
              <div className={'columnAlign'} style={{ alignItems: 'initial', flex: 1, minWidth: 0 }}>
                <div className={'primaryText'} style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 8 }} >
                  {
                    parseInt(mode) < plan.lineSynoptic?.length &&
                      plan.lineSynoptic[parseInt(mode) - 1]?.mode === 'WALK' &&
                      (
                        (
                          plan.lineSynoptic[parseInt(mode)]?.mode === 'WALK' &&
                          plan.lineSynoptic[parseInt(mode) - 1]?.mode === 'WALK'
                        ) ||
                        (
                          plan.lineSynoptic[mode]?.to.lat.toFixed(5) ===
                          VM.plannerSegments.data[inter]?.coords.latitude.toFixed(5) &&
                          plan.lineSynoptic[mode]?.to.lon.toFixed(5) ===
                          VM.plannerSegments.data[inter]?.coords.longitude.toFixed(5)
                        )
                      )
                      ? t('intermediateStop') + inter
                      : parseInt(mode) === 0 ?
                        <>
                          {VM.plannerSegments.data['origin' as any]?.name}
                          <span style={{ display: 'flex', gap: 8, alignItems: 'center', marginLeft: 'auto' }}>
                            {renderAscensorYEscaleras(mode)}
                          </span>
                        </>
                        :
                        <TextWithAccessibleRightIcon
                          text={plan.lineSynoptic[mode]?.from?.name}
                          showIcon={stopFromIsAccessible}
                          showAlert={getAlertsForStop(plan.lineSynoptic[mode]?.from).length > 0}
                        />
                  }
                </div>
                <div className={'secondaryText'} style={{ marginBlock: 'auto' }}>{`${plan.lineSynoptic[mode].distance
                  } · ${plan.lineSynoptic[mode].time} ${t('minutes')}`}</div>
              </div>
            </div>
          </div>
        );
      } 
      else { //Push Transport
        const leg = plan.lineSynoptic[mode];

        const start = leg.startTime;
        const estimated = addTestDelay(leg?.from?.estimatedArrival);

        const hasDelay = hasDelayOverOneMinute(start, estimated);

        res.push(
          <div key={mode}>
            <div className={'secondaryText row'} style={{ alignItems: 'initial' }}>

              {renderTimeWithDelay(start, estimated, hasDelay)}

              <div className={'columnAlign'}>
                {mode == '0' ? (
                  <div className={'origin'} style={{ border: `5px solid black` }} />
                ) : (
                  <div
                    className={'point'}
                    style={{
                      border: `3px solid ${
                        plan.lineSynoptic[mode].routeColor === '#FFFFFF'
                          ? plan.lineSynoptic[mode].routeTextColor
                          : plan.lineSynoptic[mode].routeColor
                      }`,
                      backgroundColor: 'white'
                    }}
                  />
                )}

                <div
                  className={'line'}
                  style={{
                    border: `1px solid ${
                      plan.lineSynoptic[mode].routeColor === '#FFFFFF'
                        ? plan.lineSynoptic[mode].routeTextColor
                        : plan.lineSynoptic[mode].routeColor
                    }`,
                    backgroundColor:
                      plan.lineSynoptic[mode].routeColor === '#FFFFFF'
                        ? plan.lineSynoptic[mode].routeTextColor
                        : plan.lineSynoptic[mode].routeColor
                  }}
                />
              </div>

              <div
                className={'columnAlign'}
                style={{ alignItems: 'initial', flex: 1, minWidth: 0 }}
              >
                <div className={'row'} style={{ alignItems: 'initial' }}>
                  <LineIcon
                    color={
                      plan.lineSynoptic[mode].routeColor === '#FFFFFF'
                        ? plan.lineSynoptic[mode].routeTextColor
                        : plan.lineSynoptic[mode].routeColor
                    }
                    textColor={
                      plan.lineSynoptic[mode].routeTextColor &&
                      plan.lineSynoptic[mode].routeColor !== '#FFFFFF'
                        ? plan.lineSynoptic[mode].routeTextColor
                        : 'white'
                    }
                    text={plan.lineSynoptic[mode].tripShortName}
                    alert={getAlertsForLeg(plan.lineSynoptic[mode]).length > 0}
                    style={{ marginRight: 5 }}
                  />

                  <TextWithAccessibleRightIcon
                    text={plan.lineSynoptic[mode]?.from?.name}
                    showIcon={stopFromIsAccessible}
                    showAlert={
                      getAlertsForStop(plan.lineSynoptic[mode]?.from).length > 0
                    }
                  />
                </div>

                <div className={'row'}>
                  <ArrowRight className={'marginRight5'} style={{ width: 16 }} />
                  <div className={'primaryText'}>
                    {plan.lineSynoptic[mode].headSign}
                  </div>
                </div>

                <div className={'margin-top-20 marginBottom20'}>
                  <RouteDetailStopCol
                    time={plan.lineSynoptic[mode].time}
                    stops={plan.lineSynoptic[mode].intermediateStops}
                    getAlertsForStop={getAlertsForStop}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }
    }

    res.push(
      <div key={'fin'}>
        <div className={'secondaryText row'} style={{ alignItems: 'initial', textAlign: 'left' }}>

          {(() => {
            const lastLeg = plan.lineSynoptic[Object.keys(plan.lineSynoptic).length - 1];

            const end = lastLeg.endTime;
            const estimatedEnd = addTestDelay(lastLeg?.to?.estimatedArrival);

            const hasEndDelay =
              lastLeg.mode !== 'WALK' &&
              hasDelayOverOneMinute(end, estimatedEnd);

            return renderTimeWithDelay(end, estimatedEnd, hasEndDelay);
          })()}

          <div className={'columnAlign'}>
            <div className={'origin'} style={{ border: `5px solid ${'black'}` }} />
          </div>
          <div className={'primaryText'}>{VM.plannerSegments.data['destination' as any]?.name}</div>
          {renderAscensorYEscaleras(Object.keys(plan.lineSynoptic).length - 1)}
        </div>
      </div>
    );

    return res;
  };

  const renderAscensorYEscaleras = (mode: any) => {
    const idEsc = `escalera_${mode}`;
    const idAsc = `ascensor_${mode}`;

    return (
      <div className="ascensores_y_escaleras" style={{ display: 'flex', gap: 8 }}>
        {plan.lineSynoptic[mode].hasStepsLeg ? (
          <>
            <ReactTooltip effect="solid" id={idEsc} />
            <div data-tip="Este tramo contiene escaleras" data-for={idEsc}>
              <Escalator className="darkGray" style={{ fontSize: 20 }} />
            </div>
          </>
        ) : null}

        {plan.lineSynoptic[mode].hasElevatorLeg ? (
          <>
            <ReactTooltip effect="solid" id={idAsc} />
            <div data-tip="Este tramo contiene ascensores" data-for={idAsc}>
              <Elevator className="darkGray" style={{ fontSize: 20 }} />
            </div>
          </>
        ) : null}
      </div>
    );
  };

  return (
    <div
      className={'paddingVertical10'}
      style={{ maxHeight: window.innerHeight - 255, overflow: 'auto' }}>
      {renderSynoptic()}
      {getRouteAlerts().length > 0 ? (
        <div className={'padding10'}>
          {renderRouteAlerts()}
        </div>
      ) : null}
      {getStopAlerts().length > 0 ? (
        <div className={'padding10'}>
          {renderStopAlerts()}
        </div>
      ) : null}
      {getMoreInformation()}
    </div>
  );
}
